import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import { useHomeAuthModal } from '../HomeAuthModalContext';

const { Title } = Typography;
const videocardPng = '/home/assets/videocard.png';

const TrainingSection = () => {
  const { openRegister } = useHomeAuthModal();
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__training" id="training">
      <div
        className="home-page__training-visual"
        aria-hidden
        style={{
          backgroundImage: `url(${videocardPng})`,
          backgroundRepeat: 'no-repeat',
          opacity: '1',
        }}
      />
      <Title level={2}>
        <FormattedMessage id={homeMessageId('training.title')} />
      </Title>
      <Button type="primary" className="btn-gradient" onClick={openRegister}>
        <FormattedMessage id={homeMessageId('button.more')} />
        <AiIcon name="btn-primary-circle-arrow-lg" />
      </Button>
    </section>
  );
};

export default TrainingSection;
